module.exports = __webpack_public_path__ + "img/27.f6a5fb64.jpg";